import type { TagProps } from '@dostavkee/web-ui'

import { V1RequestStateStringEnum } from '@/shared/api'

export const REQUEST_STATUS_TO_TEXT: Record<V1RequestStateStringEnum, string> = {
    [V1RequestStateStringEnum.requestStateIdleString]: 'Заполняется',
    [V1RequestStateStringEnum.requestStateCheckinString]: 'На проверке',
    [V1RequestStateStringEnum.requestStateAcceptString]: 'Подтверждена',
    [V1RequestStateStringEnum.requestStateDeclineString]: 'Отклонена',
    [V1RequestStateStringEnum.requestStateUnknownString]: 'Неизвестно',
}

export const REQUEST_STATUS_TO_TAG_VARIANT_MAP = new Map<
    V1RequestStateStringEnum,
    TagProps['variant']
>([
    [V1RequestStateStringEnum.requestStateIdleString, 'primary'],
    [V1RequestStateStringEnum.requestStateCheckinString, 'warning'],
    [V1RequestStateStringEnum.requestStateAcceptString, 'success'],
    [V1RequestStateStringEnum.requestStateDeclineString, 'danger'],
    [V1RequestStateStringEnum.requestStateUnknownString, 'default'],
])
